import React from "react";
import { Switch, Route } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Adjustment from "../pages/adjustment/";
import AdjustmentForm from "../pages/adjustment/form/index.js";
import Opname from "../pages/opname/";
import OpnameForm from "../pages/opname/form/index.js";
import PindahLot from "../pages/pindah-lot";
import PindahLotForm from "../pages/pindah-lot/form/index.js";

const OtherRouter = () => {
  return (
    <TransitionGroup>
      <CSSTransition classNames="fadein" timeout={300}>
        <Switch>
          <Route path="/other/adjustment" exact component={Adjustment} />
          <Route path="/other/adjustment/add" component={AdjustmentForm} />
          <Route path="/other/opname" exact component={Opname} />
          <Route path="/other/opname/add" component={OpnameForm} />
          <Route path="/other/pindah-lot/" component={PindahLot} />
          <Route path="/other/pindah/add" component={PindahLotForm} />
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default OtherRouter;
